import React from 'react';
import './ArticleCard.scss';
import Arrow from '../../../Icons/Arrow';
import { COLORS } from '../../../../../constants/colors';
import Tags from '../../../Tags/Tags';
import { truncate } from '../../../../../util/truncate';
import { titleElement } from '../../util/titleElement';

/**
 * Renders content for a article card type
 * @param {array} tags - tags associated with card/post
 * @param {string} date - the date the article was updated
 * @param {string} title - the card title/quote
 * @param {string} excerpt - the entire post body, this will be truncated on the
 * @param {string} link - the link for the card
 * @param {boolean} isFeatured
 * @param {boolean} isRecentNews
 * @param {string} backgroundColor
 * @param {boolean} isSearch
 * @returns {JSX.Element}
 * @constructor
 */
const ArticleCard = ({
  tags,
  date,
  title,
  excerpt,
  link,
  isFeatured,
  isRecentNews,
  backgroundColor,
  isSearch,
}) => {
  // Some cards need a larger title (h4)
  const largeTitle = isFeatured || isRecentNews;

  return (
    <div
      className={`c-article-card ${isFeatured ? 'is-featured' : ''} ${
        isRecentNews ? 'recent-news' : ''
      }`}
    >
      <Tags tags={tags} />
      {date && (
        <div className="c-article-card__date eyebrow-2">
          <span>{date}</span>
        </div>
      )}
      <div
        className={`c-article-card__title ${largeTitle ? 'h3' : 'h4'}-roobert ${
          !excerpt ? 'flex-grow' : ''
        }`}
      >
        {largeTitle ? titleElement('3', isSearch, title) : titleElement('4', isSearch, title)}
      </div>
      {excerpt && (
        <div
          className="c-article-card__excerpt body-2"
          dangerouslySetInnerHTML={{ __html: truncate(excerpt) }}
        ></div>
      )}
      <div className="c-article-card__cta eyebrow-1">
        <a href={link}>
          <span>Read Article</span>
          <Arrow
            color={
              isFeatured && backgroundColor === 'green'
                ? COLORS.white
                : isFeatured && (backgroundColor === 'orange' || backgroundColor === 'white')
                ? COLORS.black
                : COLORS.blue
            }
          />
        </a>
      </div>
    </div>
  );
};

export default ArticleCard;
